import React, { useContext } from 'react'
import './CookieList.css';
import { useState, useEffect } from 'react';
import { getAllCookie, getAllFavoriteItems } from '../../service/apiService';
import UserContext from '../../contexts/UserContext';
import CardItem from '../card/CardItem';
import { FavoriteContext } from '../../contexts/FavoriteContext';

export const CookieList = () => {
  const { currentUser, isRequestToGetCurrentUserDone } = useContext(UserContext);
  const [cookie, setCookie] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [page, setPage] = useState(1);
  const { favorites: favoriteItems } = useContext(FavoriteContext);
  const [errorFromServer, setErrorFromServer] = useState("");
  const getCookies = async () => {
    try {
      // Favorites are a nice-to-have (which hearts show filled) - a hiccup
      // fetching them used to throw out of this whole function and silently
      // skip the actual product fetch below, leaving the page looking empty
      // until a manual refresh. Isolated so it can never block products.
      if (currentUser && isRequestToGetCurrentUserDone) {
        try {
          const { data: fav } = await getAllFavoriteItems();
          setFavorites(fav.filter(Boolean).map(fav => fav.id));
        } catch {
          setFavorites(favoriteItems);
        }
      } else {
        setFavorites(favoriteItems);
      }
      const { data } = await getAllCookie(page, 20);
      setCookie([...cookie, ...data]);
      setPage(page + 1);
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        setErrorFromServer(err.response.data);
      } if (err.code === "ERR_NETWORK") {
        setErrorFromServer("שגיאת רשת: בדוק/י את החיבור לאינטרנט ונסה/י שוב.");
      }
      setTimeout(() => {
        setErrorFromServer('');
      }, 5000);
    }
  };
  
  useEffect(() => {
    getCookies();
  }, []);

  // getCookies() above ran once on mount, closing over whatever
  // currentUser/isRequestToGetCurrentUserDone were at that instant - the "who
  // am I" check (App.js) usually hasn't resolved yet at that point, so a
  // logged-in user landing directly here (refresh/direct link) got guest
  // favorites and it never self-corrected. Re-sync just the favorites once
  // the auth check actually resolves, same dependency Favorite.jsx already
  // uses correctly.
  useEffect(() => {
    if (!isRequestToGetCurrentUserDone) {
      return;
    }
    if (currentUser) {
      getAllFavoriteItems().then(({ data }) => setFavorites((data || []).filter(Boolean).map(fav => fav.id))).catch(() => {});
    } else {
      setFavorites(favoriteItems);
    }
  }, [currentUser, isRequestToGetCurrentUserDone]);

  return (
    <>
      <h1 className='title'>עוגיות</h1>
      <div className="cart">
        {cookie.map((cookie) => (
          <CardItem
            key={cookie.id}
            item={cookie}
            isFavoriteDefault={favorites.includes(cookie.id)}
          />
        ))}
      </div>
      <div className="load-more">
        <button className="btn" onClick={getCookies}>עוד עוגיות</button>
      </div>
    </>
  )


}
export default CookieList; 